<template>
  <v-card>
    <v-card-title class="primary white--text">
      <v-icon>fab fa-youtube</v-icon>
      <span class="title ml-2">Agregar video</span>
    </v-card-title>
    <v-card-text>
      <v-form ref="formAdd">
        <v-text-field
          v-model="video.url"
          label="URL de video"
          :error-messages="errURL"
        ></v-text-field>
        <v-text-field
          v-model="video.titulo"
          label="Título del video"
          :error-messages="errTitulo"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="error" @click="$emit('close')">
        <v-icon left>fas fa-times</v-icon>
        Cerrar
      </v-btn>
      <v-spacer />
      <v-btn color="primary" :loading="loading" @click="insertVideo">
        <v-icon left>fas fa-save</v-icon>
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required, url } from 'vuelidate/lib/validators'
const getQueryParam = (params, url) => {
  const reg = new RegExp('[?&]' + params + '=([^&#]*)', 'i')
  const queryString = reg.exec(url)
  return queryString ? queryString[1] : null
}
export default {
  data () {
    return {
      loading: false,
      video: {
        url: '',
        id_video: '',
        titulo: ''
      }
    }
  },
  computed: {
    errURL () {
      const errs = []
      if (!this.$v.video.url.$dirty) return errs
      !this.$v.video.url.required && errs.push('La URL es requerida')
      !this.$v.video.url.url && errs.push('La URL no es valida')
      return errs
    },
    errTitulo () {
      const errs = []
      if (!this.$v.video.titulo.$dirty) return errs
      !this.$v.titulo.required && errs.push('El título es requerido')
      return errs
    }
  },
  methods: {
    async insertVideo () {
      this.$v.video.$touch()
      if (!this.$v.video.$invalid) {
        try {
          this.loading = true
          const id = getQueryParam('v', this.video.url)
          this.video.id_video = id
          await this.$http.videos.post('', this.video)
          this.video.url = ''
          this.$v.video.$reset()
          this.loading = false
          this.$emit('saved')
        } catch (error) {
          this.loading = false
          window.alert('😓 Ha ocurrido un error al guardar los datos')
        }
      }
    }
  },
  validations: {
    video: {
      url: { required, url },
      titulo: { required }
    }
  }
}
</script>
